import React from 'react';
import browserHistory from 'react-router/lib/browserHistory';
import match from 'react-router/lib/match';
import Router from 'react-router/lib/Router';
import { render, unmountComponentAtNode } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import identitySelector from '../common/features/identity';
import { setupFeatureFramework } from '../common/features/splitio';

import configureStore from '../stores';
import config from '../config';

import '../styles/base.scss';

const root = document.querySelector('#root');
const preloadedState = window.__DATA__; // eslint-disable-line no-underscore-dangle
const store = configureStore(preloadedState);
const history = syncHistoryWithStore(browserHistory, store);

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const routes = require('../routes').default;

  match({ history, routes }, (error, redirectLocation, renderProps) => {
    render(
      <AppContainer>
        <Provider store={store} >
          <div>
            <Router {...renderProps} />
          </div>
        </Provider>
      </AppContainer>,
      root,
    );
  });
};

setupFeatureFramework(
  config.appKeys.splitio,
  identitySelector(store.getState()),
).then(mount).catch(mount);

// mount();

if (module.hot) {
  module.hot.accept('../routes', () => {
    unmountComponentAtNode(root);
    mount();
  });
}



// WEBPACK FOOTER //
// ./src/client/index.js